import { createTheme as createDSTheme } from 'app/shopify';
import { StyleSheet } from 'react-native';

export const theme = createDSTheme();

export const styles = StyleSheet.create({
  stepDot: {
    borderRadius: 999,
    flex: 1,
    height: 5,
  },
});
